<template>
  
    <footer class="footer text-center" >
    <div class="container" id="Contact">
      <b-row>

        <!-- Footer About Text -->
        <div class="col-lg-12 " style="margin: auto;">
          <h4 class="text-uppercase mb-4 label">About Me</h4>
          <p class="lead mb-0 label">
            I'm a Software developer. I work in .NET, Xamarin, VueJs, and loads of others frameworks. 😃 Basically my job is my passion 😁
          </p>
        </div>
    </b-row>
      <b-row>

        <!-- Footer Social Icons -->
        <div class="col-lg-4 mb-5 mb-lg-0" style="margin: auto;">
          <h4 class="text-uppercase mb-4 label">How to Reach me? </h4>
          <!-- <Social :faIcon="['fab', 'twitter']" url="https://twitter.com/BriceFriha" />  -->
          <a class="btn btn-outline-light btn-social mx-1 social" @click="gotToUrl('https://twitter.com/BriceFriha')">
            <font-awesome-icon :icon="['fab', 'twitter']" />
          </a>
          <a class="btn btn-outline-light btn-social mx-1 social" @click="gotToUrl('https://github.com/bricefriha')" >
            <font-awesome-icon :icon="['fab', 'github']" />
          </a>
          <a class="btn btn-outline-light btn-social mx-1 social" @click="gotToUrl('https://www.linkedin.com/in/brice-friha-64ba60151/')" >
            <font-awesome-icon :icon="['fab', 'linkedin']" />
          </a>
        </div>
      </b-row>
      

      </div>
  </footer>
</template>
<script>
// import Social from '../components/Socials.vue';
export default {
  components: {
      // Social,
  },
  methods: {
      // Function to go to a url
      gotToUrl(url) {
          // Open the url in anorther tab
          window.open(url, '_blank');
      }
    }
}
</script>
<style>
  .footer{
    background-color: #1a1a1a;
    padding: 10px;
    margin-top: 50px ;
  }
  .label {
    color: whitesmoke ;
  }
  .social {
    color: whitesmoke !important;
  }
  .row {
    margin-left: auto ;
    margin-right: auto ;
    margin-Top: 10px ;
    margin-bottom: 20px ;
  }
</style>